import { SUPPORT_SECTION_TRANSLATION_KEY } from '../constants';

export default {
  [SUPPORT_SECTION_TRANSLATION_KEY]: {
    SUPPORT_SECTION_TITLE: '¿Necesitas ayuda?',
    SUPPORT_SECTION_DESCRIPTION:
      '¡Estamos para atenderte! Elige el tipo de soporte según lo que necesites resolver.',
  },
};
